/**
 * @license
 * Copyright (c) 2025 Handsoncode. All rights reserved.
 */
/**
 * Base class for all types of vertices in the dependency graph
 */
export class Vertex {}